module.exports = __webpack_public_path__ + "files/db6ffc3dadfeee0e3ea271121a02058a.png";